import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css'],
})
export class ProductsComponent implements OnInit {
    argtype: string;

    argvalue: string;

    get?: ProductsGet;

    products: Item[] = [];

    constructor(private datatask: DataTaskService, private state: StateService) {
        this.argtype = state.getStateParams()['argtype'];
        this.argvalue = state.getStateParams()['argvalue'];
    }

    private async loadProducts() {
        if (!!this.argtype && !!this.argvalue) {
            this.products = await this.datatask.Post(3641, { argtype: this.argtype, argvalue: this.argvalue });
        }
    }

    private async loadGet() {
        if (!!this.argtype && !!this.argvalue) {
            this.get = (await this.datatask.Post(3642, { argtype: this.argtype, argvalue: this.argvalue }))[0];
        }
    }

    ngOnInit(): void {
        this.loadGet();
        this.loadProducts();
    }
}

interface ProductsGet {
    filter: string;
    page_heading: string;
}
